import { cva } from "class-variance-authority";
import { ComponentProps, useContext } from "react";
import { Button } from "../../../button";
import { TopBar } from "../../../top-bar";
import { DrawerSelectContext } from "../../drawer-select.context";
import styles from "./drawer-select-content-modal.module.css";

const css = cva([styles.Content], {
  variants: {
    isOpen: {
      true: styles.IsOpen,
      false: styles.IsClosed,
    },
  },
});

export type DrawerSelectContentModalProps = ComponentProps<"div">;

export function DrawerSelectContentModal({
  className,
  children,
  ...props
}: DrawerSelectContentModalProps) {
  const {
    isOpen,
    handleClear,
    handleApply,
    variant,
    multiple,
    applyButtonText,
    clearButtonText,
    modalTitle,
    modalMaxHeight,
    setIsOpen,
    isLoading,
  } = useContext(DrawerSelectContext);

  const showFooter = variant === "modal" || multiple === true;
  const applyButtonLabel = applyButtonText ?? "Confirmar";
  const clearButtonLabel = clearButtonText ?? "Limpar";
  const modalLabel = modalTitle ?? "Selecione uma opção";

  const handleBackClick = () => {
    setIsOpen(false);
  };

  const topBarRight = showFooter && {
    type: "label" as const,
    text: clearButtonLabel,
    onClick: handleClear,
  };

  return (
    <div className={css({ className, isOpen })} {...props}>
      <TopBar
        onBack={handleBackClick}
        pageTitle={modalLabel}
        right={topBarRight}
      />

      <div
        className={styles.Body}
        style={modalMaxHeight ? { maxHeight: modalMaxHeight } : undefined}
      >
        {children}
      </div>
      {showFooter && (
        <div className={styles.Footer}>
          <Button
            className={styles.ApplyButton}
            variant="situational"
            onClick={handleApply}
            data-qa="filter_make_apply_button"
            isLoading={isLoading}
          >
            {!isLoading && applyButtonLabel}
          </Button>
        </div>
      )}
    </div>
  );
}
